export default __webpack_public_path__ + "static/media/curr_copy_ac.5c0e81b6.png";